import { financeFetcher } from './fetcher';

export const createDocumentHead = (financeEntityId, data) => {
    return financeFetcher
        .post(`/document_heads/`, {
            data: {
                ...data,
                finance_entity_id: financeEntityId
            }
        })
        .then(({ response }) => response);
};

export const updateDocumentHead = (id, data) => {
    return financeFetcher.put(`/document_heads/${id}`, { data }).then(({ response }) => response);
};

export const deleteDocumentHead = id => {
    return financeFetcher.delete(`/document_heads/${id}`);
};
